import { apiGateway } from '../api';

async function envioPorArquivo(body) {
    try {
        const response = await apiGateway.post('/importar/arquivo', body);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function buscaPorArquivo(param) {
    try {
        const response = await apiGateway.get(`/importacoes/arquivos/consulta?${param}`);
        return response.data;
    } catch (error) {
        return false;
    }
}

async function buscaRelatorio(param) {
    try {
        const response = await apiGateway.get(`/importacoes/arquivos/${param}/relatorio`);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function buscaDevolutiva(param) {
    try {
        const response = await apiGateway.get(`/importacoes/arquivos/${param}/devolutiva`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export { envioPorArquivo, buscaPorArquivo, buscaRelatorio, buscaDevolutiva };
